export enum AppInitStatus {
  LOAD = 'load',
  DONE = 'done'
}
